import * as React from 'react';
import { SecondParent } from '../../../../models/child';
import { i18n } from '../../../../helpers/i18n';
import { t } from '@lingui/macro';

export const ADD_INFO = i18n._(
  t`Добавление сведений о втором родителе ребёнка`
);

export type SecondParentWithSameStatus = SecondParent & {
  value: string;
  text: string;
};

function renderSecondParentSuggestion(
  suggestion: SecondParentWithSameStatus
): JSX.Element {
  return suggestion.value === ADD_INFO ? (
    <span className="PguFormSelect_option__link">
      <span className="mos-link">{suggestion.text}</span>
    </span>
  ) : (
    <span>{suggestion.text}</span>
  );
}

export default renderSecondParentSuggestion;
